import {connect} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {Scope} from 'Shared/constants/Scope';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';

type RequireScopeProps = {
  scopes: Scope[];
  currentUserScopes: Scope[];
  lineOfBusinessScopes?: Scope[];
  children: JSX.Element;
};

const intersects = <T extends {}>(arrayOne: T[], arrayTwo: T[]) => arrayOne.some(x => arrayTwo.includes(x));

const RequireScope = (props: RequireScopeProps) => {
  return intersects(props.lineOfBusinessScopes ? props.lineOfBusinessScopes : props.currentUserScopes, props.scopes)
    ? props.children
    : null;
};

const mapStateToProps = (state: ReducerState) => ({
  currentUserScopes: selectUserScopes(state),
});

export default connect(mapStateToProps)(RequireScope);
